import './ZonesAbilitiesView.css'
import {ZoneRecord} from "../Zones";

export interface IZoneAbility {
    icon: string
    title: string
}

interface IZonesAbilitiesViewProps {
    record?: ZoneRecord
    mobile: boolean
}

export default function ZonesAbilitiesView(props: IZonesAbilitiesViewProps) {
    let ab = props.record?.abilities;
    let abilities = ab?.map((ability) => {
        let titleClass = props.mobile ? "Zones_view_legend_abilities_item_title_mobile" : "Zones_view_legend_abilities_item_title"
        let iconClass = props.mobile ? "Zones_view_legend_abilities_item_icon_mobile" : "Zones_view_legend_abilities_item_icon"
        return <div className="Zones_view_legend_abilities_item">
            <img className={iconClass} src={ability.icon}/>
            <div className={titleClass}>{ability.title.replace(/\[\/?(?:b|i|u|url|quote|code|img|color|size)*?.*?\]/img, '')}</div>
        </div>
    })

    let nf = props.record?.notifications
    let notifications = nf?.map((notification) => {
        let titleClass = props.mobile ? "Zones_view_legend_abilities_item_title_mobile" : "Zones_view_legend_abilities_item_title"
        let iconClass = props.mobile ? "Zones_view_legend_abilities_item_icon_mobile" : "Zones_view_legend_abilities_item_icon"
        return <div className="Zones_view_legend_abilities_item">
            <img className={iconClass} src="https://carsharing.s3.yandex.net/new-b2c-site/zones/min_price_icon.png"/>
            <div className={titleClass}>{notification.message.replace(/\[\/?(?:b|i|u|url|quote|code|img|color|size)*?.*?\]/img, '')}</div>
        </div>
    })

    if (abilities || notifications) {
        return <div className="Zones_view_legend_abilities">
            {abilities}
            {notifications}
        </div>
    } else {
        return <div className="Zones_view_legend_abilities">
            <div className="Zones_view_loader_box Zones_view_legend_loader"/>
            <div className="Zones_view_loader_box Zones_view_legend_loader" style={{width: "130px"}}/>
        </div>
    }
}